<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">Venues</h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
                    <template slot="header">
                        <div class="row align-items-center">
                            <div class="col-8">
                                <h3 class="mb-0" id="venues_heading">Venues</h3>
                            </div>
                            <div class="col-4 text-right">
                                <a @click.stop="showCreateCustomVenueDrawer = true"
                                    class="btn btn-outline-primary btn-sm mr-2">Create Custom Venues</a>
                                <a @click.stop="modalExportVenueRecommendations = true"
                                    class="btn btn-primary btn-sm">Export Venue Recommendations</a>
                            </div>
                        </div>
                    </template>
                    <div>
                        <el-tabs v-model="activeTab" type="border-card">
                            <el-tab-pane label="Venues" name="venues">
                                <venues-tab />
                            </el-tab-pane>
                            <el-tab-pane label="Custom Venues" name="custom_venues">
                                <custom-venues-tab ref="customVenuesTab" />
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </card>
            </div>
        </div>
        <modal :show.sync="modalExportVenueRecommendations" body-classes="p-0"
            modal-classes="modal-dialog-centered modal-md">
            <ExportVenueRecommendations />
        </modal>
        <CreateCustomVenueDrawer :visible.sync="showCreateCustomVenueDrawer" @venue-created="onCustomVenueCreated" />
    </div>
</template>

<script>
import { Tabs, TabPane } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import ExportVenueRecommendations from '@/views/Widgets/Venues/ExportVenueRecommendations';
import CreateCustomVenueDrawer from '@/views/Widgets/Venues/CreateCustomVenueDrawer';
import VenuesTab from './VenuesTab';
import CustomVenuesTab from './CustomVenuesTab';

export default {
    components: {
        RouteBreadCrumb,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
        ExportVenueRecommendations,
        CreateCustomVenueDrawer,
        VenuesTab,
        CustomVenuesTab,
    },
    data() {
        return {
            activeTab: "venues",
            showCreateCustomVenueDrawer: false,
            modalExportVenueRecommendations: false,
        };
    },
    methods: {
        onCustomVenueCreated(venue) {
            this.showCreateCustomVenueDrawer = false;
            this.$refs.customVenuesTab.addCustomVenue(venue);
            this.activeTab = "custom_venues";
        },
    },
};
</script>

<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
